export const MAX_CHUNK_SIZE = 1024 * 1024;
export const TIME_TO_WAIT = 400;

export const SUCCESS_CHUNK_STATUS = [308];
export const SUCCESS_FINAL_CHUNK_STATUS = [200, 201];

export const MAX_RETRIES = 5;
